export const faqs = [
  {
    q: "看料大瓜主要提供什么内容？",
    a: "我们聚焦热点事件的现场信息，以「现场直击」和「瓜田情报」两条内容线为主。现场直击侧重事件当天的实际情况与目击者描述，瓜田情报则侧重事件来龙去脉的梳理与后续进展。",
  },
  {
    q: "网站上的内容是怎么来的？",
    a: "内容由编辑团队根据公开信息整理，并结合现场目击者的描述进行交叉核对。对于尚无法确认的信息，我们会在文中明确标注为「待核实」，避免把传闻当作事实传播。",
  },
  {
    q: "为什么有的文章会有一个时间线？",
    a: "当事件在较短时间内连续发生变化时，时间线能帮读者快速看清「什么时候发生了什么」。我们会尽量用简洁的短句记录关键节点，并在有新进展时更新。",
  },
  {
    q: "如何找到某个主题的全部内容？",
    a: "在「现场直击」页面可以按明星现场、影视野台、城市现场、赛事直击、网络风云等主题进行筛选，也可以直接使用顶部导航在两条内容线之间切换。",
  },
  {
    q: "内容出现错误或需要补充怎么办？",
    a: "欢迎通过页脚的邮箱与我们联系。若信息确有出入，我们会在核实后尽快更正，并在文末注明修改说明。",
  },
  {
    q: "网站会收集我的个人信息吗？",
    a: "浏览内容本身不需要注册，也不会收集个人信息。只有在你主动通过邮件与我们联系时，我们才会收到你提供的联系方式，并仅用于回复沟通。",
  },
];

export const testimonials = [
  {
    name: "阿禾",
    role: "老瓜民 · 关注三年",
    text: "最舒服的一点是时间线，事件一多就不容易乱。早上刷一遍就知道昨晚发生了什么，不用再翻十几个帖子。",
  },
  {
    name: "Leo",
    role: "上班族 · 通勤阅读",
    text: "排版很干净，没有那种铺天盖地的弹窗。地铁上十分钟能看完两篇，重点一眼就能抓到。",
  },
  {
    name: "圆子",
    role: "内容创作者 · 素材参考",
    text: "标注「待核实」这点很加分。做二创的时候最怕把不确定的消息当真，这里至少给了判断的余地。",
  },
];